import { render } from "./PlayerPanel.vue?vue&type=template&id=48342c13&scoped=true"
import script from "./PlayerPanel.vue?vue&type=script&lang=js"
export * from "./PlayerPanel.vue?vue&type=script&lang=js"

import "./PlayerPanel.vue?vue&type=style&index=0&id=48342c13&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48342c13"]])

export default __exports__